const readStringEnv = (envValue: string | undefined): string | null => {
  let target: string | null = null;
  if (envValue !== undefined && envValue.length !== 0) {
    target = envValue;
  }
  return target;
};

export default readStringEnv;
